export var PluginToolbarButtons;
(function(PluginToolbarButtons) {
    PluginToolbarButtons[PluginToolbarButtons["BEST_FIT"] = 0] = "BEST_FIT";
    PluginToolbarButtons[PluginToolbarButtons["FULL_WIDTH"] = 1] = "FULL_WIDTH";
    PluginToolbarButtons[PluginToolbarButtons["ALIGN_LEFT"] = 2] = "ALIGN_LEFT";
    PluginToolbarButtons[PluginToolbarButtons["ALIGN_RIGHT"] = 3] = "ALIGN_RIGHT";
    PluginToolbarButtons[PluginToolbarButtons["LINK"] = 4] = "LINK";
    PluginToolbarButtons[PluginToolbarButtons["REPLACE"] = 5] = "REPLACE";
    PluginToolbarButtons[PluginToolbarButtons["DELETE"] = 6] = "DELETE";
    PluginToolbarButtons[PluginToolbarButtons["SEPARATOR"] = 7] = "SEPARATOR";
    PluginToolbarButtons[PluginToolbarButtons["LAYOUT_GRID"] = 8] = "LAYOUT_GRID";
    PluginToolbarButtons[PluginToolbarButtons["LAYOUT_MASONRY"] = 9] = "LAYOUT_MASONRY";
    PluginToolbarButtons[PluginToolbarButtons["SETTINGS"] = 10] = "SETTINGS";
    PluginToolbarButtons[PluginToolbarButtons["REFRESH"] = 99] = "REFRESH";
})(PluginToolbarButtons || (PluginToolbarButtons = {}));
